/* eslint-disable @typescript-eslint/no-unused-vars */
import { useEffect, useState } from 'react'
import { FaClipboardList, FaCog, FaComment, FaDownload, FaFile, FaFileCsv, FaFileImage, FaFileVideo, FaFolder, FaMapMarkerAlt, FaUserAlt } from 'react-icons/fa'
import { appApi } from '../../../../../../../services/appApi'
import { ButtonCmp } from '../../../../../../../components/ButtonCmp'
import { PropInvalida } from '../../../../../../../Utils/Helper'
import { Flex, Spinner, useToast } from '@chakra-ui/react'
import { Column, FileBox, GuideText, LabelFile, LabelSelecionado, VideoBox } from './styles'
import { ElementoTooltipCmp } from '../../../../../../../components/ElementoTooltipCmp'
import { BsFillFileEarmarkPdfFill } from 'react-icons/bs'
interface iProps {
  colabId: string
  etapaId: string
}

export const ObservacaoFile: React.FC<iProps> = ({ colabId, etapaId }) => {
  const toast = useToast()

  const [Arquivo, setArquivo] = useState('')
  const [SpinnerOn, setSpinnerOn] = useState(false)

  const [PodeSubirArquivo, setPodeSubirArquivo] = useState(false)

  const [Tamanho, setTamanho] = useState('')
  const [NomeArquivo, setNomeArquivo] = useState('')

  function ObterPermissaoSubirArquivo(): void {
    appApi.get('Colaborador/PodeSubirArquivo')
      .then(res => {
        setPodeSubirArquivo(res.data)
      })
      .catch(err => console.log(err))
  }

  function ObterEtapa(): void {
    appApi.get(`EtapaColaborador/${colabId}/Etapa/${etapaId}/file`)
      .then(res => {
        setTamanho(res.data.size)
        setArquivo(res.data.uri)
        setNomeArquivo(res.data.name)
      })
      .catch(err => console.log(err))
  }

  const AtualizarArquivo = (event: any): void => {
    setSpinnerOn(true)
    const formdata = new FormData()
    formdata.append('request', event.target.files[0])

    appApi.post(`EtapaColaborador/${colabId}/Etapa/${etapaId}/uploadfile`, formdata).then(resposnse => {
      setTamanho(resposnse.data.size)
      setArquivo(resposnse.data.uri)
      setNomeArquivo(resposnse.data.name)
      toast({
        title: 'Arquivo cadastrado com sucesso',
        status: 'success',
        isClosable: false,
        position: 'top-right',
        duration: 2000
      })
      setSpinnerOn(false)
    }).catch(() => {
      toast({
        title: 'Arquivo excedeu o limite de 25 MB',
        status: 'error',
        isClosable: false,
        position: 'top-right',
        duration: 2000
      })
      setSpinnerOn(false)
    })
  }

  function GetFileIcon(tipo: string): any {
    const tipoFormatado = tipo.toLowerCase()
    switch (tipoFormatado) {
      case 'csv':
        return <FaFileCsv size={21}/>
      case 'svg':
      case 'jpeg':
      case 'png':
      case 'jpg':
        return <FaFileImage size={21}/>
      case 'pdf':
        return <BsFillFileEarmarkPdfFill size={21}/>
      case 'mov':
      case 'mp4':
        return <FaFileVideo size={21}/>
      default:
        return <FaFile size={21}/>
    }
  }

  useEffect(() => {
    ObterEtapa()
    ObterPermissaoSubirArquivo()
  }, [])

  return (
      <FileBox>
              {
                (!Arquivo || Arquivo.length === 0)
                  ? <>
                    {PodeSubirArquivo && <><input id={etapaId} type={'file'} onChange={(e) => { AtualizarArquivo(e) }} />
                    <ElementoTooltipCmp label={'Tamanho limite de 25mb para upload'} bg={'var(--Azul)'}>
                      <LabelFile theme={'1961E0'} htmlFor={etapaId}>{SpinnerOn
                        ? <Spinner></Spinner>
                        : <><FaFolder /> Adicionar arquivo de observação</>}</LabelFile>
                    </ElementoTooltipCmp></>}
                  </>
                  : <>
                    <Flex marginBottom={'1rem'}>
                      <Flex gap={'.5rem'} alignItems={'center'}>
                        <Flex h={'1.5rem'}>
                          {GetFileIcon(NomeArquivo.split('.')[NomeArquivo.split('.').length - 1])}
                        </Flex>
                        <Column>
                          <span>{NomeArquivo}</span>
                          <small>Tamanho: {Tamanho}</small>
                        </Column>
                        <ButtonCmp ml={'.5rem'} VarColor='Green2' onClick={() => { window.location.href = Arquivo }}><FaDownload/></ButtonCmp>
                      </Flex>
                    </Flex>
                    {PodeSubirArquivo && <><input id={etapaId} type={'file'} onChange={(e) => { AtualizarArquivo(e) }} />
                    <ElementoTooltipCmp label={'Tamanho limite de 25mb para upload'} bg={'var(--Azul)'}>
                      <LabelFile theme={'1961E0'} htmlFor={etapaId}>{SpinnerOn
                        ? <Spinner></Spinner>
                        : <><FaFolder /> Alterar arquivo de observação</>}</LabelFile>
                    </ElementoTooltipCmp></>}
                  </>
              }
      </FileBox>
  )
}
